export enum InvoicingType {
  Regular = "REGULAR",
  Fee = "FEE",
  TrueUp = "TRUE_UP"
}